var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex xs12 md12 w-table" },
    [
      _c("vuestic-widget", { attrs: { id: "dategridPayOrder" } }, [
        _c("div", { staticClass: "va-row" }, [
          _c("div", { staticClass: "flex md6" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("t.requestLog20")) + "\n        "
            ),
          ]),
          _c("div", { staticClass: "flex md6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm",
                attrs: { id: "myBtnWrapper" },
                on: { click: _vm.handleRefresh },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("translate")("basic.button.refresh")) +
                    "\n          "
                ),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "table-responsive mt-2",
            attrs: { id: "waybillDownload" },
          },
          [
            _c("table", { staticClass: "table table-striped" }, [
              _c("thead", [
                _c(
                  "tr",
                  _vm._l(_vm.tableHeaderList, function (item, index) {
                    return _c("th", { key: index }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("translate")(item.label)) +
                          "\n            "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm.list
                ? _c(
                    "tbody",
                    _vm._l(_vm.list, function (item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(" " + _vm._s(item.id) + " ")]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.timeZoneValue(item.conditions))),
                        ]),
                        _c("td", [
                          _vm._v(" " + _vm._s(item.create_time) + " "),
                        ]),
                        _c("td", [
                          _vm._v(" " + _vm._s(item.update_time) + " "),
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDownloadResult(item.result)) +
                              " "
                          ),
                        ]),
                        _c("td", [
                          item.download_url
                            ? _c("a", { attrs: { href: item.download_url } }, [
                                _c("i", { staticClass: "el-icon-download" }),
                                _vm._v(_vm._s(_vm.$t("t.download"))),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [
                    _c("tr", [
                      _c("td", {
                        attrs: { colspan: "11" },
                        domProps: { textContent: _vm._s(_vm.noData) },
                      }),
                    ]),
                  ]),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }